import {
  contentHeight,
  onyxGreenColor,
  onyxGreenAccentColor
} from "assets/jss/default/theme.js";

export function timeOut(loading) {
  return { ...(!loading ? { timeout: 1000 } : {}) };
}

const casePageStyle = theme => ({
  detailSection: {
    backgroundColor: "#FFF",
    height: contentHeight
  },
  streamSection: {
    padding: "0px 20px",
    height: contentHeight,
    position: "relative"
  },
  streamItem: {
    paddingBottom: "30px"
  },
  machineStatusTablePadding: {
    padding: "0px 15px"
  },
  addButton: {
    position: "absolute",
    bottom: theme.spacing(0),
    right: theme.spacing(5),
    zIndex: 3,
    background: onyxGreenColor,
    transition: theme.transitions.create(["background", "transform"], {
      duration: theme.transitions.duration.complex
    }),
    "&:hover": {
      background: onyxGreenAccentColor,
      transform: "scale(1.1)"
    }
  },
  saveButton: {
    marginLeft: "auto",
    bottom: theme.spacing(-1),
    right: theme.spacing(3),
    background: onyxGreenColor,
    transition: theme.transitions.create(["background", "transform"], {
      duration: theme.transitions.duration.complex
    }),
    "&:hover": {
      background: onyxGreenAccentColor,
      transform: "scale(1.1)"
    }
  },
  unsavedChangesNotification: {
    marginLeft: 35
  },
  saveActionContainer: {
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    bottom: theme.spacing(6),
    right: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      bottom: 0,
      right: 0,
      position: "relative",
      width: "auto",
      paddingBottom: 15
    },
    [theme.breakpoints.up("md")]: {
      right: "50%",
      width: "48%"
    }
  },
  scrollBarPadding: {
    paddingRight: "12px"
  },
  caseNotFoundItem: {
    padding: theme.spacing(3)
  }
});

export default casePageStyle;
